import { render } from "./AdicionarCaminhao.vue?vue&type=template&id=1a4df8b9&scoped=true&ts=true"
import script from "./AdicionarCaminhao.vue?vue&type=script&lang=ts"
export * from "./AdicionarCaminhao.vue?vue&type=script&lang=ts"

import "./AdicionarCaminhao.vue?vue&type=style&index=0&id=1a4df8b9&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4df8b9"]])

export default __exports__